module.exports = __webpack_public_path__ + "static/home-ferry1-17f3bfe87ffc7b89d2ac7f85b9a9cfb3.png";